import socket from '@/plugins/socket'
import Game from '@/store/model/sport/sport/Game'
import { date } from '@/helpers/format'

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false
  },
  mutations: {
    load: (state, datas) => {
      datas = datas.sort((a, b) => {
        if (b.date && a.date) {
          const dateA = new Date(a.date)
          const dateB = new Date(b.date)
          return dateA.getTime() - dateB.getTime()
        } else {
          return a.order - b.order
        }
      })

      state.list.splice(0)
      datas.forEach(item => { state.list.push(new Game(item)) })
      state.loading = false

      // search
      const ids = []
      for (const i in state.list) {
        ids.push(state.list[i].id)
      }

      if (ids.length > 0) {
        const parameters = {
          type: 'get',
          namespace: 'Search',
          module: 'Games',
          callback: 'Sport/Game/searchActive',
          parameters: ids
        }

        socket.send(parameters)
      }
    },
    searchActive: (state, datas) => {
      if (datas) {
        for (const i in datas) {
          const game = state.list.find(item => item.id === datas[i])
          if (game) {
            game.search = true
          }
        }
      }
    },
    searchLoad: (state, datas) => {
      if (datas) {
        if (datas.gameId) {
          const game = state.list.find(item => item.id === datas.gameId)
          if (game) {
            game.searching = false
            game.searchNotification = datas
          }
        }
      }
    },
    single: (state, datas) => {
      if (datas) {
        for (const i in datas) {
          const dataGame = datas[i]
          const game = state.list.find(item => item.id === dataGame.id)
          for (const j in dataGame) {
            if (dataGame[j] !== game[j]) {
              game[j] = dataGame[j]
            }
          }
        }
      }
    }
  },
  actions: {
    set (state, data) {
      if (data.sportId > 0 || data.competitionsId > 0 || data.dateStart || data.dateEnd) {
        state.state.list = []
        state.state.loading = true

        const parameters = {
          columns: {
            groupTypeId: 'SportSportGroup.groupTypeId',
            roundTypeId: 'SportSportRound.roundTypeId',
            competitionId: 'SportSportCompetitionseason.competitionId',
            seasonId: 'SportSportCompetitionseason.seasonId',
            sportId: 'SportSportDiscipline.sportId',
            disciplineId: 'SportSportEvent.disciplineId',
            eventId: 'SportSportEventunit.eventId',
            genderId: 'SportSportEventunit.genderId',
            eventUnitId: 'SportSportEventunit.id'
          },
          join: [
            'SportSportGame.dayId',
            'SportSportDay.groupId',
            'SportSportGroup.roundId',
            'SportSportRound.competitionSeasonId',
            'SportSportRound.eventUnitId',
            'SportSportEventunit.eventId',
            'SportSportEvent.disciplineId'
          ]
        }

        if (data.dateStart) {
          parameters.dateStart = { column: 'date', operator: '>=', value: date(data.dateStart) }
        }
        if (data.dateEnd) {
          const dateEnd = new Date(data.dateEnd.getTime())
          dateEnd.setDate(dateEnd.getDate() + 1)
          parameters.dateEnd = { column: 'date', operator: '<=', value: date(dateEnd) }
        }

        if (data.dayId > 0) {
          parameters.dayId = data.dayId
        } else {
          if (data.groupsTypeId > 0) {
            if (data.groupsTypeId.length === 1) {
              parameters['SportSportGroup.groupTypeId'] = data.groupsTypeId[0]
            } else {
              parameters['SportSportGroup.groupTypeId'] = {
                column: 'SportSportGroup.groupTypeId',
                operator: 'in',
                value: data.groupsTypeId
              }
            }
          }

          if (data.roundsTypeId > 0) {
            if (data.roundsTypeId.length === 1) {
              parameters['SportSportRound.roundTypeId'] = data.roundsTypeId[0]
            } else {
              parameters['SportSportRound.roundTypeId'] = {
                column: 'SportSportRound.roundTypeId',
                operator: 'in',
                value: data.roundsTypeId
              }
            }
          }

          // competition
          if (data.seasonId > 0 || data.competitionsId.length > 0) {
            if (data.seasonId > 0) {
              parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
            }

            if (data.competitionsId.length === 1) {
              parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
            } else if (data.competitionsId.length > 1) {
              parameters['SportSportCompetitionseason.competitionId'] = {
                column: 'SportSportCompetitionseason.competitionId',
                operator: 'in',
                value: data.competitionsId
              }
            }
          }

          // discipline
          if (data.eventUnitsId > 0) {
            parameters['SportSportRound.eventUnitId'] = {
              value: data.eventUnitsId,
              operator: 'in'
            }
          } else {
            if (data.categoryId > 0) {
              parameters['SportSportEventunit.categoryId'] = data.categoryId
            }

            if (data.eventId > 0) {
              parameters['SportSportEventunit.eventId'] = data.eventId
            } else if (data.disciplineId > 0) {
              parameters['SportSportEvent.disciplineId'] = data.disciplineId
            } else if (data.sportId > 0) {
              parameters['SportSportDiscipline.sportId'] = data.sportId
            }

            if (data.genderId > 0) {
              parameters['SportSportEventunit.genderId'] = data.genderId
            }

            // todo : Classification
          }
        }

        socket.get('SportSportGame', 'Sport/Game/load', parameters)
      }
    },
    search (state, id) {
      const game = state.state.list.find(item => item.id === id)
      game.searching = true
      game.searchNotification = null

      const parameters = {
        type: 'put',
        namespace: 'Search',
        module: 'Games',
        callback: 'Sport/Game/searchLoad',
        value: id
      }

      socket.send(parameters)
    },
    put (state, parameters) { socket.put('SportSportGame', 'Sport/Game/single', parameters) }
  },
  getters: {
    loading: (state) => state.loading,
    list: (state) => state.list
  }
}
